import { setSidebarOpenTab } from '@/atoms/persistedPreferencesAtoms';
import { useTranslatorAccess } from '@/hooks/useTranslatorAccess';
import { Languages } from 'lucide-react';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useMobilePanel } from '../../mobile';
import { NavItem } from '../nav-item';

export function TranslatorNavItem() {
  const intl = useIntl();
  const { isTranslatorShown } = useTranslatorAccess();
  const { dismissMobileSidebar } = useMobilePanel();

  const onClick = useCallback(() => {
    setSidebarOpenTab(undefined);
    dismissMobileSidebar();
  }, [dismissMobileSidebar]);

  if (!isTranslatorShown) {
    return null;
  }

  return (
    <NavItem
      label={intl.formatMessage({
        defaultMessage: 'Translator',
        description: 'Sidebar nav item for the Translator tab',
        id: 'WrkGIkyMQI',
      })}
      icon={<Languages />}
      href="/translator"
      onClick={onClick}
      testId="sidebar-link-view-translator"
    />
  );
}
